// extracted by mini-css-extract-plugin
export var statItem = "_jd-1";
export var statsRow = "_jd-0";